<div class="main-content">
  <div class="container-fluid">
    <div class="meeting-step-header">
      <h4>{{ isPss ? 'Closure' : 'Final Meeting' }}</h4>
      <p *ngIf="!isPss" class="meeting-step-subtitle">
        Wrap up the service: schedule the final call, mark it as completed, then submit your activity report.
      </p>
      <p *ngIf="isPss" class="meeting-step-subtitle">
        Wrap up the service: make sure the activity report is complete, then submit it to close the service.
      </p>
    </div>

    <router-outlet *ngIf="!loading" name="meeting_5"></router-outlet>
  </div>
</div>
